import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import debug from 'debug'
import config from './config'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

if (config.get('isLocal')) {
  debug.enable('app*,store*,router*,view*,component*,api*,helper*')
  debug('app')('Initialized')

  // make the global store available on the window for local development
  window.STORE = store
}

export default router
